<template>
  <div class="row">
    <div class="col-md-12 card">
      <form class="form-horizontal">
        <div class="card-header">
          <h4 class="card-title">
            
          </h4>
        </div>
        <div class="card-content">
          <fieldset>
            <div class="form-group">
              <label class="col-sm-2 control-label">New Category</label>
              <div class="col-sm-6">
                <input type="text"
                      name="category"
                      data-vv-as="Category"
                      v-validate="modelValidations.category"
                      v-model="model.category"
                      class="form-control">
                <small class="text-danger" v-show="category.invalid">
                  {{ getError('category') }}
                </small>
              </div>
              <div class="col-sm-4">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="card-footer">
          <p-button type="info" @click.prevent="validate" class="info" round>{{ model.saveCategoryButtonText }}</p-button>
        </div>
      </form>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">
            
        </h4>
      </div>
      <div class="card-content">
      
        <p-button v-for="(value, name, index) in model.usersCategories" v-bind:key="index" type="success" 
        @click.prevent="deleteCategory (value.value)" v-bind:id="'categoryButton_' + value.value"  round>
            <i slot="label" class="nc-icon nc-simple-remove"></i>
            {{ value.label }} 
        </p-button>
        
      </div>
  </div>
</div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, TimePicker, Slider, Tag, Input, Button, Select, Option} from 'element-ui'

  export default {
    computed: {
      ...mapFields(['category'])
    },
    data () {
      return {
        model: {
          category: '',
          usersCategories: [],
            
          saveCategoryButtonText: 'Save Category',
        },
        modelValidations: {
          category: {
            required: true
          }
        },
       
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.createCategory (this.model.category)
        })
      },
      createCategory (categoryName) {
       
        this.model.saveCategoryButtonText = 'Saving Category ...'

        this.$http.post('/categories', {
          name: categoryName,

        })
        .then(response=>{
          
          let newCategory = response.data
          let newUserCategory = new Object

          newUserCategory.value = newCategory.id 
          newUserCategory.label = newCategory.name

          this.model.usersCategories.push(newUserCategory)

          this.model.saveCategoryButtonText = 'Category Saved. Save Another'
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
          console.log(error)
        })
      },

      fetchUsersCategories () {
        this.$http.get('/categories/user')
          
          .then(response => {
            let categories = response.data
            console.log (categories)

            let selectCategory = []

            for(let key = 0; key < categories.length; key++) {

              let selectOption = new Object
              selectOption.value = categories[key]['id']
              selectOption.label = categories[key]['name']
              
              selectCategory[key] = selectOption
              
            }

            this.model.usersCategories = selectCategory
            
          })
          .catch(err => console.error(err))
        
      },

      deleteCategory (category_id) {

        this.$http.delete('/categories/'+ category_id, {
          id: category_id,
        })
        .then(response=>{
          let hideCategory = 'categoryButton_' + category_id
          document.getElementById(hideCategory).style.display = 'none'

        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
          console.log(error)
        })
      }
    },
    
    beforeMount () {
      this.fetchUsersCategories ()
    },

    
    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.enterPressed)
    }
  }
</script>
